<div class= "page page--partner-analytics">
  <div class="page__container">
    <h1 class="page__title  h2" translate>partner_setup_title</h1>
    <div class="my-5">
    <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
      <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>partner_setup_nav_link</button>
      <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
        <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
          partner_setup_nav_link
        </button>
        <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
          partner_setup_nav_coupon
        </button>
        <button ngbDropdownItem translate (click)="nav.select(3); dropdown.innerText = $event.target.innerText">partner_setup_nav_manual</button>
      </div>
    </div>
    <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device custom" [(activeId)]="activeId">
      <li [ngbNavItem]="1">
        <a ngbNavLink translate>partner_setup_nav_link</a>
        <ng-template ngbNavContent>
          <wsb-partner-clientsetup-link></wsb-partner-clientsetup-link>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink translate>partner_setup_nav_coupon</a>
        <ng-template ngbNavContent>
          <wsb-partner-clientsetup-discountcode></wsb-partner-clientsetup-discountcode>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <a ngbNavLink translate>partner_setup_nav_manual</a>
        <ng-template ngbNavContent>
          <wsb-partner-clientsetup-newreferral></wsb-partner-clientsetup-newreferral>
        </ng-template>
      </li>
    </ul>
  </div>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
</div>

